import React from "react";
import SignupComp from "../../components/RegistrationComponents/Signup/Signup";

function Signup() {
  return <SignupComp />;
}

export default Signup;
